var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 14.01V7H9.33301V14.01H6.33301L10.333 18L14.333 14.01H11.333ZM4.33301 0L0.333008 3.99H3.33301V11H5.33301V3.99H8.33301L4.33301 0ZM11.333 14.01V7H9.33301V14.01H6.33301L10.333 18L14.333 14.01H11.333ZM4.33301 0L0.333008 3.99H3.33301V11H5.33301V3.99H8.33301L4.33301 0Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingArrow);
export default __webpack_public_path__ + "static/media/sorting_arrow.d54b25458c66fbea3e183a60c32e5110.svg";
export { ForwardRef as ReactComponent };